import { render, staticRenderFns } from "./SaleProgramG.vue?vue&type=template&id=67313776"
import script from "./SaleProgramG.vue?vue&type=script&lang=js"
export * from "./SaleProgramG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports